import { render, staticRenderFns } from "./WANotification.vue?vue&type=template&id=18a7ac8e&scoped=true"
import script from "./WANotification.vue?vue&type=script&lang=js"
export * from "./WANotification.vue?vue&type=script&lang=js"
import style0 from "./WANotification.vue?vue&type=style&index=0&id=18a7ac8e&prod&lang=css"
import style1 from "./WANotification.vue?vue&type=style&index=1&id=18a7ac8e&prod&lang=scss&scoped=true"
import style2 from "./WANotification.vue?vue&type=style&index=2&id=18a7ac8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a7ac8e",
  null
  
)

export default component.exports